import { TableLayout } from 'components/ui/templates/TableLayout/TableLayout';

import { PayoutsHeader } from './PayoutsHeader';
import { PayoutsTable } from './PayoutsTable';

export const Payouts = () => {
  return <TableLayout header={<PayoutsHeader />} content={<PayoutsTable />} />;
};
